import React, { useRef, useState } from "react";
import { MdPlayCircle } from "react-icons/md";

interface VideoProps extends React.VideoHTMLAttributes<HTMLVideoElement> {
  url: string;
  type?: string;
  fallback?: React.ReactNode;
}

const Video: React.FC<VideoProps> = ({
  url,
  type = "video/mp4",
  fallback = "ビデオは利用できません",
  ...props
}) => {
  // ref for video element
  const videoRef = useRef<HTMLVideoElement>(null);

  const [isPlayed, setIsPlayed] = useState(false);

  const [error, setError] = useState(false);

  const handleError = () => setError(true);

  const playVideo = () => {
    if (videoRef.current) {
      videoRef.current.play();
      setIsPlayed(true);
    }
  };

  // Check video play false

  if (error) {
    return <div>{fallback}</div>;
  }

  // Custom a play icon button

  return (
    <div className="relative">
      <video
        ref={videoRef}
        {...props}
        controls={isPlayed}
        onError={handleError}
        onPause={() => setIsPlayed(false)}
      >
        <source src={url} type={type} />
        {fallback}
      </video>
      {!isPlayed && (
        <div className="absolute inset-0 flex items-center justify-center bg-black/70">
          <MdPlayCircle
            className="text-white size-9 cursor-pointer"
            onClick={playVideo}
          />
        </div>
      )}
    </div>
  );
};

export { Video };
